var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOurBlog = function SvgIconOurBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.191 15.5H.809L4 9.118zM15.191 15.5H8.809L12 9.118zM4.809.5h6.382L8 6.882z"
  })));
};
export { SvgIconOurBlog as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTkwOTggMTUuNUgwLjgwOTAxN0w0IDkuMTE4MDNMNy4xOTA5OCAxNS41WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTE1LjE5MSAxNS41SDguODA5MDJMMTIgOS4xMTgwM0wxNS4xOTEgMTUuNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik00LjgwOTAyIDAuNTAwMDAxTDExLjE5MSAwLjVMOCA2Ljg4MTk3TDQuODA5MDIgMC41MDAwMDFaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";